/* eslint-disable no-shadow */

export enum SocialLinks {
  linkedin = 'https://www.linkedin.com/in/santiago-souza-49778b1b2/',
  twitter = 'https://twitter.com/elpatino_',
  github = 'https://github.com/makis-san',
  instagram = 'https://instagram.com/euosantiago_'
}
